export default __webpack_public_path__ + "static/media/skipped.10d08f98.svg";